module.exports = __webpack_public_path__ + "static/media/edit.88b2a0cd.svg";